import List from 'src/storage/list';
import { validateObj } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';
import mainModel from './model';

class ManagerInvitationsModel extends List {
  id = 'ManagerInvitationsModel';
  defaultState = () => ({
    ...this.defaultInviteInput(),
    current: 'recent',
    total: 0,
    pageIndex: 0,
    sortBy: {
      sortKey: 'managerAddedDate',
      desc: true
    },
    updating: {}
  });

  refreshOnInit = true;
  refreshOnSubscribe = false;
  sortBy = null;

  apiConfig = {
    refresh: {
      url: 'invitation/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'invitation/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'invitation/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    invite: {
      url: 'invitation/send/manager',
      validation: {
        email: 'email',
        fullname: 'fullName',
        phoneNumber: 'phone'
      },
      cancellable: true
    },
    update: {
      url: 'invitation/update',
      validation: {
        hospitalIds: 'hospitalIds'
      },
      cancellable: true
    },
    invite_detail: {
      url: 'invitation/detail',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    },
    remove: {
      url: 'invitation/remove',
      validation: {},
      cancellable: true
    },
    bulk: {
      url: 'invitation/bulk/manager',
      validation: {},
      cancellable: true
    },
    resend: {
      url: 'invitation/resend',
      validation: {},
      cancellable: true
    }
  };

  _events = {
    'ws:invite_manager': 'onManager',
    location: 'initLocation',
    profile: 'handleChangeProfileAndSwitchAccount'
  };

  defaultInviteInput = () => ({
    tab: 'search',
    email: '',
    fullname: '',
    managerAccess: [],
    phoneNumber: '',
    account: null,
    bulkList: Array.from({ length: 10 }, () => ({}))
  });

  resetInviteInput = () => {
    this.setState({
      ...this.cacheState,
      ...this.defaultInviteInput()
    });
  };

  onManager = (data) => {
    if (data.managerRemovedDate) this.removeItem(data.id);
    else {
      this._mergeItems([data], null, true);

      this.trigger();
    }
  };
  _matchMergeItem = (n, o) => {
    return {
      ...o,
      ...n
    };
  };

  listParams() {
    const user = this.getUser();
    const clinicId = user?.isClinic ? user.id : user.managerToClinic;
    let req = {
      skip: this.state.pageIndex * this.listLimit,
      limit: this.listLimit,
      sortBy: this.state.sortBy,
      role: 'manager_' + clinicId
    };
    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    return req;
  }

  remove = (item, cb) => {
    let req = {
      id: item.id
    };
    this.api('remove', req, (err, data, success) => {
      cb && cb(err, data, success);
      !err && this.removeItem(item.id);
    });
  };
  sendInvite = (cb) => {
    let req = {
      email: this.input('email') || '',
      fullname: this.input('fullname'),
      phoneNumber: this.input('phoneNumber') || '',
      managerAccess: this.input('managerAccess') || []
    };

    if (req.phoneNumber && req.phoneNumber[0] === '+' && req.phoneNumber.length < 4) {
      req.phoneNumber = '';
    }

    if (this.state.tab === 'search') {
      req = {
        id: this.state.account?.id,
        email: this.state.account?.email,
        fullname: this.state.account?.fullNameLower,
        phoneNumber: this.state.account?.phoneNumber,
        managerAccess: this.state.managerAccess
      };
    } else {
      let invalid = validateObj(req, this.apiConfig.invite.validation);

      if (!req.email && !req.phoneNumber) {
        invalid.emailOrPhone = LANG_CONST.validation.email_or_phone;
        invalid.length++;
      }

      if (invalid.length) {
        return this.setInvalidApi('invite', invalid);
      }
    }
    this.api('invite', req, (err, data, success) => {
      cb && cb(err, data, success);
      if (success) {
        this.resetInviteInput();
        if (data.invitation) this.onManager({ ...data.invitation });
        if (data.manager) {
          mainModel.onManager({ ...data.manager });
          mainModel.setState({ tab: 'managers' });
        }
      }
    });
  };

  sendBulk = (cb) => {
    const id = 'bulk';
    this.api(id, { users: this.state.bulkList }, cb);
  };

  sendImport = (req, cb) => {
    const id = '/invitation/bulk/manager';
    this.upload(id, req, () => null, cb);
  };
  resend = (id, cb) => {
    let req = {
      id
    };
    this.api('resend', req, (err, data, success) => {
      !!data?.invitation && this.onManager(data.invitation);
      cb && cb(err, data, success);
    });
  };
}

const model = new ManagerInvitationsModel();
export default model;
